import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import api from '../../config/api'
import { persistAuth } from '../../config/authUtils'

const Login = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        setError(null)
        try {
            const response = await api.post('/auth/login/', { email, password })

            persistAuth(response.data)
            navigate('/')
        } catch (err) {
            console.error('Login failed', err)
            setError(
                err.response?.data?.detail ||
                err.response?.data?.message ||
                'Login failed. Please check your credentials.'
            )
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="main-wrapper auth-bg position-relative overflow-hidden">

            {/* Start Content */}
            <div className="container-fluid position-relative z-1">
                <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">

                    {/* Start Row */}
                    <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap py-3">

                        <div className="col-lg-4 mx-auto">
                            <div className="d-flex justify-content-center align-items-center">
                                <div className="d-flex flex-column justify-content-lg-center p-4 p-lg-0 pb-0 flex-fill">

                                    {/* Logo */}
                                    <div className="mx-auto mb-4 text-center">
                                        <img src="/assets/img/media/burray.png" className="img-fluid" width="100" alt="Logo" />
                                    </div>

                                    <div className="card border-0 p-lg-3 rounded-4">
                                        <div className="card-body">
                                            <div className="text-center mb-3">
                                                <h5 className="mb-1 fw-bold">Sign In</h5>
                                                <p className="mb-0">Please enter below details to access the dashboard</p>
                                            </div>

                                            {/* Login Form */}
                                            <form onSubmit={handleSubmit} noValidate>

                                                {/* Error Alert */}
                                                {error && (
                                                    <div className="alert alert-danger py-2 mb-3" role="alert">
                                                        <i className="ti ti-alert-circle me-2" />
                                                        {error}
                                                    </div>
                                                )}

                                                {/* Email Field */}
                                                <div className="mb-3">
                                                    <label htmlFor="login-email" className="form-label">
                                                        Email Address
                                                    </label>
                                                    <div className="input-group input-group-flat">
                                                        <span className="input-group-text">
                                                            <i className="ti ti-mail fs-14 text-dark" />
                                                        </span>
                                                        <input
                                                            id="login-email"
                                                            type="email"
                                                            name="email"
                                                            className="form-control"
                                                            placeholder="Enter Email Address"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            required
                                                            autoComplete="email"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Password Field */}
                                                <div className="mb-3">
                                                    <label htmlFor="login-password" className="form-label">
                                                        Password
                                                    </label>
                                                    <div className="input-group input-group-flat">
                                                        <span className="input-group-text">
                                                            <i className="ti ti-lock-open fs-14 text-dark" />
                                                        </span>
                                                        <input
                                                            id="login-password"
                                                            type={showPassword ? 'text' : 'password'}
                                                            name="password"
                                                            className="pass-input form-control ps-1"
                                                            placeholder="************"
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            required
                                                            autoComplete="current-password"
                                                        />
                                                        <span
                                                            className={`input-group-text ti ${showPassword ? 'ti-eye' : 'ti-eye-off'} fs-14 text-dark`}
                                                            role="button"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => setShowPassword((prev) => !prev)}
                                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Forgot Password */}
                                                <div className="d-flex align-items-center justify-content-end mb-3">
                                                    <a href="/forgot-password">Forgot Password?</a>
                                                </div>

                                                {/* Submit Button */}
                                                <div className="mb-2">
                                                    <button
                                                        id="login-submit-btn"
                                                        type="submit"
                                                        className="btn btn-primary w-100"
                                                        disabled={loading}
                                                    >
                                                        {loading
                                                            ? <BeatLoader color="#fff" size={8} />
                                                            : 'Login'
                                                        }
                                                    </button>
                                                </div>

                                            </form>
                                            {/* End Login Form */}

                                        </div>{/* end card body */}
                                    </div>{/* end card */}

                                </div>
                            </div>
                        </div>{/* end col */}

                    </div>
                    {/* End Row */}

                </div>
            </div>
            {/* End Content */}

        </div>
    )
}

export default Login
